module.exports = __webpack_public_path__ + "img/e.8086c489.jpg";